import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import classNames from "classnames";
import DeliverySection from "./DeliverySection";
import JoditEditor from "jodit-react";
import { getData } from "../../../utils/api";
import { Select2Data } from "../../../utils/common";
import Select from "react-select";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    control,
    setValue,
    formState: { errors },
    trigger,
  } = useForm();
  const imageFile = watch("image");

  const onSubmit = async (data) => {

    try {
    
      const DataToSend = new FormData();
      DataToSend.append("name", data.name);
      DataToSend.append("sub_name", data.sub_name);
      DataToSend.append("term_condition", data.term_condition);
      if (data.plan_feture_id) {
        DataToSend.append(
          "plan_feture_id",
          JSON.stringify(data.plan_feture_id.map((option) => option.value))
        );
      }
      
      if (data?.image?.length > 0) {
        DataToSend.append("image", data.image[0]);
      }

      // Intake Direction
      const intake_direction = [];
      data.intake_direction?.forEach((item, index) => {
        intake_direction.push({
          name: item.name,
          sub_name: item.sub_name,
        });

        if (item?.image?.length > 0) {
          DataToSend.append(`intake_image${index}`, item.image[0]);
        }
      });
      DataToSend.append("intake_direction", JSON.stringify(intake_direction));

      // Nutritions
      const nutritions =
        data.nutritions?.map((item) => ({ name: item.name })) || [];
      DataToSend.append("nutritions", JSON.stringify(nutritions));

      // Plan Prices
      const plan_price =
        data.plan_price?.map((item) => ({
          duration: item.duration,
          price: item.price,
        })) || [];
      DataToSend.append("plan_price", JSON.stringify(plan_price));

      // Weeks + Deliveries
      const weeks = [];
      data.weeks?.forEach((week, wIndex) => {
        const weekObj = {
          days_id: week.days_id?.map((day) => day.value) || [],
          deliveries: [],
        };

        week.deliveries?.forEach((delivery, dIndex) => {
          weekObj.deliveries.push({
            duration: delivery.duration,
            price: delivery.price,
            category_id: delivery.category_id?.value,
            product_id: delivery.product_id?.value,
            quantity: delivery.quantity,
            calories: delivery.calories,
            serving_size: delivery.serving_size,
          });
        });

        weeks.push(weekObj);
      });
      DataToSend.append("weeks", JSON.stringify(weeks));

      const response = await postData(`/admin/subscription/plan`, DataToSend);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };
  const { fields, append, remove } = useFieldArray({
    control,
    name: "plan_price",
  });

  const {
    fields: weekFields,
    append: appendWeek,
    remove: removeWeek,
  } = useFieldArray({
    control,
    name: "weeks",
  });
  const {
    fields: intakeDirectionFields,
    append: appendIntakeDirection,
    remove: removeIntakeDirection,
  } = useFieldArray({
    control,
    name: "intake_direction",
  });

  const {
    fields: nutritionFields,
    append: appendNutrition,
    remove: removeNutrition,
  } = useFieldArray({
    control,
    name: "nutritions",
  });
  console.log(getValues(), "getValues getValues");
  const [days, setDays] = useState([]);
  const getAllDays = async () => {
    const response = await getData("/common/masters/all-days");
    if (response?.success) {
      setDays(await Select2Data(response?.data, "day_id"));
    }
  };

  const [planFeture, setPlanFeture] = useState([]);
  const getPlanFeture = async () => {
    const response = await getData("/common/masters/all-plan-feture");
    if (response?.success) {
      setPlanFeture(await Select2Data(response?.data, "plan_feture_id"));
    }
  };
  useEffect(() => {
    getAllDays();
    getPlanFeture();
  }, []);
  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Add Plan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Plan  <span className="required-star">*</span></Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Plan Name..."
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required: "Plan Name is required",
                             validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Plan Sub Title  <span className="required-star">*</span></Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Plan Name..."
                        className={classNames("", {
                          "is-invalid": errors?.sub_name,
                        })}
                        {...register("sub_name", {
                          required: "Plan Sub Name is required",
                             validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.sub_name && (
                      <span className="text-danger">
                        {errors.sub_name.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Image  <span className="required-star">*</span></Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="file"
                        name="image"
                        placeholder="Image"
                        className={classNames("", {
                          "is-invalid": errors?.image,
                        })}
                        {...register("image", {
                          required: "Image is required",
                        })}
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                    </InputGroup>
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}
                  </Form.Group>
                  {imagePreview && (
                    <div className="mt-2">
                      <img
                        src={imagePreview}
                        alt="Category Preview"
                        style={{ maxWidth: "100px" }}
                      />
                    </div>
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Plan Feture  <span className="required-star">*</span></Form.Label>
                    </div>
                    <InputGroup>
                      <Controller
                        name="plan_feture_id"
                        {...register("plan_feture_id", {
                          required: "Select Plan Feture",
                        })}
                        control={control}
                        render={({ field }) => (
                          <Select
                            isMulti
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.plan_feture_id
                                  ? "red"
                                  : baseStyles,
                              }),
                            }}
                            {...field}
                            options={planFeture}
                          />
                        )}
                      />
                    </InputGroup>
                    {errors.plan_feture_id && (
                      <span className="text-danger">
                        {errors.plan_feture_id.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>
              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Term Condition  <span className="required-star">*</span></Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Controller
                          name="term_condition"
                          control={control}
                          rules={
                            {
                              // required: "Content is required.",
                              // maxLength: {
                              //   value: 600,
                              //   message:
                              //     "content must be at most 600 characters long.",
                              // },
                            }
                          } // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("term_condition");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                      </InputGroup>
                      {errors.term_condition && (
                        <span className="text-danger">
                          {errors.term_condition.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <div className="oder-detail-holder mb-3">
                <div className="heading-holder">
                  <h6> Plan Price</h6>
                </div>

                <div className="package-details-section">
                  {fields.map((variant, index) => (
                    <div key={variant.id} className="main-form-section mt-3">
                      <Row>
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Duration(in Month)  <span className="required-star">*</span></Form.Label>
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  name={`plan_price.${index}.duration`} // Register color for the variant
                                  placeholder="Duration"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.plan_price?.[index]?.duration,
                                  })}
                                  {...register(`plan_price.${index}.duration`, {
                                    required: "Variant MRP is required",
                                       validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                                  })}
                                  onKeyDown={(e) => {
                                    // Allow backspace, left and right arrow keys
                                    if (
                                      e.key === "Backspace" ||
                                      e.key === "ArrowLeft" ||
                                      e.key === "ArrowRight"
                                    ) {
                                      return; // Allow the action to continue
                                    }

                                    // Allow digits and decimal point
                                    if (!/[\d.]/.test(e.key)) {
                                      e.preventDefault(); // Block the invalid key
                                    }

                                    // Prevent multiple decimal points
                                    if (
                                      e.key === "." &&
                                      e.target.value.includes(".")
                                    ) {
                                      e.preventDefault(); // Block adding another decimal point
                                    }
                                  }}
                                />
                                {errors?.plan_price?.[index]?.duration && (
                                  <span className="text-danger">
                                    {errors.plan_price[index].duration.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label> Price  <span className="required-star">*</span></Form.Label>
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  name={`plan_price.${index}.price`} // Register color for the variant
                                  placeholder="Variant Price"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.plan_price?.[index]?.price,
                                  })}
                                  {...register(`plan_price.${index}.price`, {
                                    required: "Variant name is required",
                                       validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                                  })}
                                  onKeyDown={(e) => {
                                    // Allow backspace, left and right arrow keys
                                    if (
                                      e.key === "Backspace" ||
                                      e.key === "ArrowLeft" ||
                                      e.key === "ArrowRight"
                                    ) {
                                      return; // Allow the action to continue
                                    }

                                    // Allow digits and decimal point
                                    if (!/[\d.]/.test(e.key)) {
                                      e.preventDefault(); // Block the invalid key
                                    }

                                    // Prevent multiple decimal points
                                    if (
                                      e.key === "." &&
                                      e.target.value.includes(".")
                                    ) {
                                      e.preventDefault(); // Block adding another decimal point
                                    }
                                  }}
                                />
                                {errors?.plan_price?.[index]?.price && (
                                  <span className="text-danger">
                                    {errors.plan_price[index].price.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                      {fields.length > 1 && (
                        <button
                          className="mt-3 add-varient"
                          type="button"
                          onClick={() => remove(index)} // Remove the variant
                        >
                          Remove Plan Price
                        </button>
                      )}
                      <hr />
                    </div>
                  ))}
                </div>
                <hr />
                <div className="text-center">
                  <button
                    type="button"
                    className="add-varient"
                    onClick={() => append({})}
                  >
                    + Add Plan Price
                  </button>
                </div>
              </div>
              <div className="oder-detail-holder mb-3">
                <div className="heading-holder">
                  <h6>Nutrition</h6>
                </div>

                <div className="package-details-section">
                  {nutritionFields.map((variant, index) => (
                    <div key={variant.id} className="main-form-section mt-3">
                      <Row>
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Name</Form.Label>
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  name={`nutritions.${index}.name`} // Register color for the variant
                                  placeholder="Name"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.plan_price?.[index]?.name,
                                  })}
                                  {...register(`nutritions.${index}.name`, {
                                    required: "name is required",
                                       validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                                  })}
                                />
                                {errors?.nutritions?.[index]?.name && (
                                  <span className="text-danger">
                                    {errors.nutritions[index].name.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                      {nutritionFields.length > 1 && (
                        <button
                          className="mt-3 add-varient"
                          type="button"
                          onClick={() => removeNutrition(index)} // Remove the variant
                        >
                          Remove Nutrition
                        </button>
                      )}
                      <hr />
                    </div>
                  ))}
                </div>
                <hr />
                <div className="text-center">
                  <button
                    type="button"
                    className="add-varient"
                    onClick={() => appendNutrition({})}
                  >
                    + Add Nutrition
                  </button>
                </div>
              </div>
              <div className="oder-detail-holder mb-3">
                <div className="heading-holder">
                  <h6>Intake Direction</h6>
                </div>

                <div className="package-details-section">
                  {intakeDirectionFields.map((variant, index) => (
                    <div key={variant.id} className="main-form-section mt-3">
                      <Row>
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Name</Form.Label>
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  name={`intake_direction.${index}.name`} // Register color for the variant
                                  placeholder="Duration"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.intake_direction?.[index]?.name,
                                  })}
                                  {...register(
                                    `intake_direction.${index}.name`,
                                    {
                                      required: "Name is required",
                                    }
                                  )}
                                />
                                {errors?.intake_direction?.[index]
                                  ?.duration && (
                                  <span className="text-danger">
                                    {
                                      errors.intake_direction[index].duration
                                        .message
                                    }
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Details</Form.Label>
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  name={`intake_direction.${index}.sub_name`} // Register color for the variant
                                  placeholder="Duration"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.intake_direction?.[index]
                                        ?.sub_name,
                                  })}
                                  {...register(
                                    `intake_direction.${index}.sub_name`,
                                    {
                                      required: "sub_name is required",
                                    }
                                  )}
                                />
                                {errors?.intake_direction?.[index]
                                  ?.sub_name && (
                                  <span className="text-danger">
                                    {
                                      errors.intake_direction[index].sub_name
                                        .message
                                    }
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Image</Form.Label>
                              <Form.Group>
                                <Form.Control
                                  type="file"
                                  name={`intake_direction.${index}.image`}
                                  placeholder="Image"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.intake_direction?.[index]?.image,
                                  })}
                                  {...register(
                                    `intake_direction.${index}.image`,
                                    {
                                      required: "Image is required",
                                      validate: async (value) => {
                                        if (typeof value !== "string") {
                                          // const fileTypes = [
                                          //   "jpg",
                                          //   "png",
                                          //   "jpeg",
                                          // ];
                                          // const fileType =
                                          //   value[0].name?.split(".")[1];
                                        }
                                      },
                                    }
                                  )}
                                  accept="image/*"
                                  // onChange={(e) => handleImageprojectChange(e, index)}
                                />
                                {errors?.intake_direction?.[index]?.image && (
                                  <span className="text-danger">
                                    {
                                      errors.intake_direction[index].image
                                        .message
                                    }
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                      {intakeDirectionFields.length > 1 && (
                        <button
                          className="mt-3 add-varient"
                          type="button"
                          onClick={() => removeIntakeDirection(index)} // Remove the variant
                        >
                          Remove Intake Direction
                        </button>
                      )}
                      <hr />
                    </div>
                  ))}
                </div>
                <hr />
                <div className="text-center">
                  <button
                    type="button"
                    className="add-varient"
                    onClick={() => appendIntakeDirection({})}
                  >
                    + Add Intake Direction
                  </button>
                </div>
              </div>
              <div className="oder-detail-holder mb-3">
                <div className="heading-holder">
                  <h6>Weeks</h6>
                </div>

                <div className="package-details-section">

                {weekFields.map((week, index) => (
                  <div key={week.id} className="mb-4 p-3 border">
                    <h5>Week {index + 1}</h5>
                    <Col md={4}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Week Days</Form.Label>
                          <Form.Group>
                            <Controller
                              name={`weeks.${index}.days_id`} // name of the field
                              {...register(`weeks.${index}.days_id`, {
                                required: "Select product",
                              })}
                              control={control}
                              render={({ field }) => (
                                <Select
                                  isMulti
                                  styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                      borderColor: errors?.weeks?.[index]
                                        ?.days_id
                                        ? "red"
                                        : baseStyles,
                                    }),
                                  }}
                                  {...field}
                                  options={days}
                                />
                              )}
                            />
                            {errors?.weeks?.[index]?.days_id && (
                              <span className="text-danger">
                                {errors?.weeks?.[index]?.days_id.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>
                    <DeliverySection
                      key={index}
                      nestIndex={index}
                      control={control}
                      register={register}
                      getValues={getValues}
                      errors={errors}
                      setValue={setValue}
                    />
                    <button type="button" className="add-varient  mt-3 mx-2" onClick={() => removeWeek(index)}>
                      Remove Week
                    </button>
                  </div>
                ))}
                </div>
              </div>
              <hr />
              <div className="text-center">
                <button
                  type="button"
                  className="add-varient mt-3"
                  onClick={() =>
                    appendWeek({ deliveries: [{ duration: "", price: "" }] })
                  }
                >
                  + Add Week
                </button>
              </div>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
